$(function () {

  // Check if the user has a country set in cookies
  if ($.cookie('country')) {
    changeCountry($.cookie('country'));
  } else {
    changeCountry('UK');
  }

  // Quick Quote Country
  if ($('.quick-quote').length > 0 || $('.quick-quote__side').length > 0) {
    $('.quick-quote .dropdown-toggle, .quick-quote__tab .dropdown-toggle, .quick-quote__side .dropdown-toggle').on('click', function () {
      $(this).closest('.quick-quote__actions__dropdown').toggleClass('active');
    });
  }

  //quick quote country contact
  if ($('.dropdown-list__country').length > 0) {
    $('.dropdown-list__country').click(function () {
      changeCountry($(this).data('country'));
      $(this).closest('.quick-quote__actions__dropdown').toggleClass('active');
    });
  }
});

function changeCountry(country) {
  $('.dropdown-toggle__item, .dropdown-list__country, .quick-quote__side .contact, .quick-quote__contact').removeClass('active');
  $('.dropdown-toggle__item.' + country + ', .dropdown-list__country[data-country=' + country + '], .quick-quote__contact.'+ country + '').addClass('active');
  $('.quick-quote__side .contact.' + country).addClass('active');
  $.cookie('country', country, {expires: 7, path: '/'});

}



// WEBPACK FOOTER //
// ./scripts/components/quickquote.js